<template>
  <div>
    <TableFilters
      :filters="['search', 'dateRange', 'cheqStatus', 'cheqFor']"
      :columns="columns"
      @updateColumnsTable="updateColumnsTable"
      v-model="filter"
      :export="[`productexport`]"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn
            @click="
              goto('indextable');
              viewpdfFile();
            "
          >
            View Report
          </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-card class="lighten-12 mt-2" v-show="false">
      <v-container fluid class="light gray lighten-12">
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="chequesList"
              item-key="id"
              style="margin-top: 100"
              class="row-pointer product-list"
              id="indextable5"
            >
              <template v-slot:no-data>
                <div class="mt-16 container justify-center item-center">
                  <noData name="Cheques" />
                </div>
              </template>
              <template v-slot:item.cheque_no="{ item }">
                <CopyTableCell :text="item.cheque_no"></CopyTableCell>
              </template>
              <!-- created at -->
              <template v-slot:item.date_time="{ item }">{{
                item.date_time ? item.date_time : '-'
              }}</template>
              <!-- Cheque final date -->
              <template v-slot:item.cheque_date="{ item }">{{
                item.cheque_date ? item.cheque_date : '-' | formatDate
              }}</template>
              <!-- Purchase or sale type -->
              <template v-slot:item.paymentable_type="{ item }">{{
                item.paymentable_type ? item.paymentable_type : '-'
              }}</template>
              <!-- Cheque status -->
              <template v-slot:item.status="{ item }">{{
                item.status ? item.status : '-'
              }}</template>
              <!-- Beneficery name -->
              <!-- <template v-slot:item.supplier="{ item }">{{
                item.purchase.supplier.name
                  ? item.purchase.supplier.name
                  : "......."
              }}</template> -->
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import noData from '@/components/shared/noItem';
import ProductListPdf from '../PDF/ProductsList.vue';
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import { mapState } from 'vuex';
export default {
  data: () => ({
    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.no,
      },
      {
        text: 'Created on',
        value: 'date_time',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.date_time,
      },
      {
        text: 'Cheque No',
        value: 'cheque_no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.cheque_no,
      },
      {
        text: 'Cheque Date',
        value: 'cheque_date',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => moment(item?.cheque_date).format('YYYY-MM-DD'),
      },
      {
        text: 'Cheque For',
        value: 'paymentable_type',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.paymentable_type,
      },
      {
        text: 'Beneficery Name',
        value: 'supplier',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.purchase?.supplier?.name,
      },
      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.status,
      },
    ],
    chequesList: [],
    hide: '',
    // Filters
    filter: {
      search: '',
      start: '',
      end: '',
      cheqStatus: '',
      cheqFor: '',
    },
  }),
  components: {
    PageTitle,
    TableFilters,
    noData,
    ProductListPdf,
  },
  computed: {
    ...mapState(['filterDatas']),

    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },

  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      this.$store.commit('UPDATE_PDF_VISIBLE', true);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

      var filter = this.filter;
      this.$store
        .dispatch('report/getChequeReports', filter)
        .then((res) => {
          let i = 1;
          this.chequesList = res.data.data;
          this.chequesList.map((p) => {
            p.no = i;
            i++;
          });
          setTimeout(() => {
            // Update Pdf To List

            this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
            // Update Pdf To List Datas
            this.$store.commit('UPDATE_PDF_DATAS', this.chequesList);
            // Update Pdf To List_Title
            this.$store.commit('UPDATE_PDF_TITLE', 'Cheques');
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            callBack();
          }, 100);
        })
        .catch((err) => {
          this.isLoading = false;
          this.$store.commit('UPDATE_PDF_VISIBLE', false);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);

          this.messages = err.data.title;
        });
    },

    async viewpdfFile() {
      await this.generateReport();
      if (this.chequesList.length > 0) {
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }
    },

    exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.chequesList);
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Product Report', 14, 6);

        doc.setFontSize(8);
        doc.text(
          250,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-Product.pdf`);
      };
      this.generateReport(printPdf);
    },
    //Cheque Details Export Pdf
    async exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.chequesList);
        for (let x = 0; x < Data.length; x++) {
          Data[x].date_time = Data[x].date_time;
          Data[x].cheque_no = Data[x].cheque_no;
          Data[x].cheque_date = Data[x].cheque_date;
          Data[x].paymentable_type = Data[x].paymentable_type;
          Data[x].supplier = Data[x].purchase?.supplier?.name;
          Data[x].status = Data[x].status;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Cheque Report', 15, 5);

        doc.setFontSize(9);
        doc.text(
          246,
          5,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        doc.setFontSize(9);

        const conditions = [
          { key: 'cheqStatus', label: 'Cheque Status' },
          { key: 'cheqFor', label: 'Cheque For' },
        ];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(
            condition.key,
            condition.label,
            value,
            condition.offset,
          );

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5;
          }

          return acc;
        }, 12); // Initial offset

        // Add Date Range if both start and end are available
        if (this.filterDatas.start && this.filterDatas.end) {
          const dateRangeText = `Date Range - ${this.filterDatas.start} - ${this.filterDatas.end}`;
          doc.text(dateRangeText, 15, height);
          height += 5; // Increment offset
        }

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-Cheque Report.pdf`);
      };
      this.generateReport(printPdf);
    },
    //Cheque Details Export Excel
    async exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable5');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-Purchase Report.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
    goto(id) {
      var element = document.getElementById(id);
      element.scrollIntoView({ behavior: 'smooth' });
    },
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
};
</script>
<style>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  border-radius: 6px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 31px;
}
</style>
